const moneyFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

const twoDecimalFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export function formatMoney(money: string) {
  return moneyFormat.format(parseFloat(money));
}

export function formatRawMoney(money: number) {
  return twoDecimalFormat.format(money);
}
